<template>
  <div class="wxdev-box">
    <div class="en-title">{{ "WeChat".toUpperCase() }}</div>
    <div class="cn-title">微信平台开发</div>
    <div class="content" v-html="cleanHtmlText(data.content)"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
